import { Center, HStack, Skeleton, View, VStack } from "native-base";
import React from "react";
import DeviceSkeleton from "./DeviceSkeleton";
interface Props {
  isKioskMode?: boolean;
}
const AreaItemSkeleton = (props: Props) => {
  const { isKioskMode } = props;
  return (
    <Center w="100%" maxW="720" rounded="lg" py="15px" px="5px">
      <HStack
        style={isKioskMode ? { minHeight: 45 } : null}
        w="100%"
        space={6}
        alignItems="center"
        mb="10px"
      >
        {!isKioskMode && (
          <Skeleton
            borderWidth={1}
            borderColor="coolGray.200"
            size="45px"
            rounded="md"
          />
        )}
        <Skeleton h="3" w="50%" maxW="150" rounded="full" />
        <Skeleton h="3" w="20%" rounded="full" />
      </HStack>
      <View
        w="100%"
        flexDirection="row"
        flexGrow={1}
        justifyContent="space-around"
      >
        <DeviceSkeleton isKioskMode={isKioskMode} />
        <DeviceSkeleton isKioskMode={isKioskMode} />
        {/* {isKioskMode && <DeviceSkeleton isKioskMode={isKioskMode} />} */}
      </View>
    </Center>
  );
};

export default AreaItemSkeleton;
